export default {
    computed: {
        bestInterest() {
            return Math.min(...this.lenders.map(lender => lender.model.minInterestPossible));
        },
        bestEffectiveInterest() {
            return Math.min(...this.lenders.map(lender => lender.model.minEffectiveInterestPossible));
        },
        bestMinAge() {
            return Math.min(...this.lenders.map(lender => lender.model.minAge));
        },
        bestSetupFee() {
            return Math.min(...this.lenders.map(lender => lender.model.setupFee));
        },
        bestRating() {
            return Math.max(...this.lenders.map(lender => lender.model._ratings.average_score)) || false;
        },
        bestAmountOfBanks() {
            return Math.max(...this.lenders.map(lender => lender.model.connectedBanks)) || false;
        },
        bestTrustpilotRating() {
            return Math.max(...this.lenders.map(lender => lender.model.trustpilotScore)) || false;
        },
    }
};